import React, { Fragment } from "react";
import { observer } from "mobx-react-lite";
import styled from "styled-components";
import Modal from 'react-modal';
import { useTranslation } from "react-i18next";
import { CustomModalStyles, ModalDeleteCloseButtonBar, ModalTitle } from "../modal/ModalComponents";
import { AiFillDelete } from "react-icons/ai";
import { mainMapEditorStore } from "../../stores/MapEditorStore";
const DangerButton = styled.button.withConfig({
  displayName: "MapDeleteButton__DangerButton",
  componentId: "sc-2vemvv-0"
})(["color:", ";display:flex;flex-direction:row;flex-shrink:0;margin:2px;cursor:pointer;"], props => props.disabled ? '#AAAAAA' : '#DD0000');
const DeleteIcon = styled(AiFillDelete).withConfig({
  displayName: "MapDeleteButton__DeleteIcon",
  componentId: "sc-2vemvv-1"
})(["margin-right:2px;"]);
export const MapDeleteButton = observer(({
  onConfirm,
  disabled
}) => {
  const {
    currentMap
  } = mainMapEditorStore.currentMapStore;
  const {
    t
  } = useTranslation();
  const [modalIsOpen, setIsOpen] = React.useState(false);

  function openModal() {
    setIsOpen(true);
  }

  function closeModal(e) {
    e === null || e === void 0 ? void 0 : e.stopPropagation();
    setIsOpen(false);
  }

  function confirm() {
    closeModal();
    onConfirm();
  }

  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(DangerButton, {
    disabled: disabled,
    onClick: openModal
  }, /*#__PURE__*/React.createElement(DeleteIcon, null), " ", t("editor.delete_map")), /*#__PURE__*/React.createElement(Modal, {
    isOpen: modalIsOpen,
    onRequestClose: closeModal,
    style: CustomModalStyles,
    shouldCloseOnOverlayClick: true,
    shouldCloseOnEsc: true
  }, /*#__PURE__*/React.createElement(ModalTitle, null, t("editor.delete_map_dialog_title")), t("editor.delete_map_dialog_message", {
    name: currentMap ? currentMap.properties.name : ""
  }), /*#__PURE__*/React.createElement(ModalDeleteCloseButtonBar, {
    confirm: confirm,
    closeModal: closeModal
  })));
});